import * as React from 'react'

import {
  Button,
  Checkbox,
  Dialog,
  Flex,
  Form,
  Paragraph,
  Select,
  Textarea,
} from '@buffer-mono/popcorn'

import style from '../../Profile/ProfileSettings.module.css'

import type { JSX } from 'react'

const ConfirmRemoveAccountModal = ({
  onConfirm,
  close,
  isOpen,
}: {
  onConfirm: (reason: { reason: string; message: string }) => void
  close: () => void
  isOpen: boolean
}): JSX.Element => {
  const [reason, setReason] = React.useState('')
  const [message, setMessage] = React.useState('')
  const [confirmed, setConfirmed] = React.useState(false)
  const canSubmit = reason !== '' && confirmed

  function handleSubmit(): void {
    if (canSubmit) {
      onConfirm({ reason, message })
    }
  }

  return (
    <Dialog modal open={isOpen}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>
            You&apos;re about to delete your Buffer account
          </Dialog.Title>
          <Dialog.Description>
            We would love to know more, please choose from the options below.
          </Dialog.Description>
        </Dialog.Header>
        <Dialog.Body>
          <Form name="confirmRemoveAccount">
            <Flex direction="column" gap="md">
              <Form.Field name="reason" className={style.fullWidth}>
                <Form.Label>Why are you deleting your account?</Form.Label>
                <Select name="reason" onValueChange={setReason}>
                  <Form.Control>
                    <Select.Trigger
                      placeholder="Select a reason"
                      data-testid="reason-select"
                      style={{ justifyContent: 'space-between' }}
                    />
                  </Form.Control>
                  <Select.Content>
                    <Select.Item value="extenuating-circumstances">
                      Extenuating Circumstances (e.g. illness, budget cuts,
                      etc.)
                    </Select.Item>
                    <Select.Item value="not-using-anymore">
                      I don&apos;t use the product anymore
                    </Select.Item>
                    <Select.Item value="too-expensive">
                      Too expensive
                    </Select.Item>
                    <Select.Item value="missing-features">
                      Missing features
                    </Select.Item>
                    <Select.Item value="bugs">
                      Bugs or usability issues
                    </Select.Item>
                    <Select.Item value="others">Other</Select.Item>
                  </Select.Content>
                </Select>
              </Form.Field>
              <Form.Field name="message" className={style.fullWidth}>
                <Form.Label>
                  Can you provide more detail about your answer above?
                </Form.Label>
                <Form.Control>
                  <Textarea
                    resize="auto"
                    rows={1}
                    onChange={(e): void => {
                      setMessage(e.target.value)
                    }}
                  />
                </Form.Control>
              </Form.Field>
              <Form.Field name="confirmCheckbox" className={style.fullWidth}>
                <Paragraph className={style.confirmDeleteText}>
                  Please keep in mind that{' '}
                  <b>deleting your Buffer account is permanent</b> and will
                  delete all account data stored with Buffer. This includes
                  publishing, engagement, and analytics. However, we will not
                  remove any historical posts made to a channel.
                </Paragraph>
                <Form.Control name="confirmCheckbox">
                  <Checkbox
                    onChange={(checked): void => {
                      setConfirmed(checked === true)
                    }}
                    name="confirmCheckbox"
                  >
                    Yes, I would like to delete my account
                  </Checkbox>
                </Form.Control>
              </Form.Field>
            </Flex>
          </Form>
        </Dialog.Body>
        <Dialog.Footer>
          <Button variant="tertiary" onClick={close}>
            Cancel
          </Button>

          <Button
            variant="critical"
            onClick={handleSubmit}
            disabled={!canSubmit}
          >
            Delete My Account
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}

export default ConfirmRemoveAccountModal
